import React, { Fragment, useState, useRef, useEffect } from 'react'
import showdown from 'showdown';

import { Dialog, Transition } from '@headlessui/react'
import { XIcon } from '@heroicons/react/outline'


import {
    apiGetUserChangelog, apiUpdateUser
  } from 'src/utils/journeyApi';

import { trackSegmentEvent } from 'src/utils/segment';


const convertMarkdownToHTML = (markdown: string) => {
    const converter = new showdown.Converter({openLinksInNewWindow: true});
    converter.setOption('simpleLineBreaks', true);
    return converter.makeHtml(markdown);
  };

type CannyEntryType = Array<any> | null;

const ChangelogModal = () => {
    const cancelButtonRef = useRef(null)

    const [openTimelinePost, setOpenTimelinePost] = useState(false)

    const [entries, setEntries] = useState<CannyEntryType>(null)

    const [lastChangeTime,setLastChangeTime] = useState(null);


    const initiateChangeLog = () => {

        apiGetUserChangelog()
        .then(changelog => {

            if(changelog.status){

                if(changelog.changeObject && changelog.changeObject.changeList && changelog.changeObject.changeList.length>0){

                    setEntries(changelog.changeObject.changeList);
                    setLastChangeTime(changelog.changeObject.lastTime)
                    setOpenTimelinePost(true)

                    trackSegmentEvent('Changelog Opened',{});
                }
            }
        })
        .catch(()=>{
          trackSegmentEvent('Changelog Error',{type:'Fetch API'})
        })
  

    }

    const initiateUpdateLastTime = () => {

        const params = {
            last_seen_product_update: lastChangeTime,
          };

        apiUpdateUser(params).then(() => {
          trackSegmentEvent('Changelog Closed',{});
        })
        .catch(()=>{
          trackSegmentEvent('Changelog Error',{type:'Update API'})
        })
    }

    useEffect(()=>{
            initiateChangeLog();
    },[])

    const cancelModal = () => {
      initiateUpdateLastTime()
      setOpenTimelinePost(false)
    }

    return (
        <Transition.Root show={openTimelinePost} as={Fragment}>
        <Dialog as="div" className="fixed inset-0 overflow-y-auto" style={{zIndex:999}} initialFocus={cancelButtonRef} onClose={()=>cancelModal()}>
          <div className="flex items-start mt-2 justify-center min-h-screen  px-4 pb-20 text-center ">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo= "opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>
  
            {/* This element is to trick the browser into centering the modal contents. */}
            <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
              &#8203;
            </span>

            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >             
              <div className="inline-block align-bottom bg-white rounded-lg px-2 sm:px-4 pt-3 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-2xl sm:w-full sm:p-6">
              <div className="py-6 px-4  sm:px-6 rounded-lg bg-gradient-to-b ">
                         <div className="flex items-center justify-between">
                            <div className='block'>
                           <h2 className="text-2xl  font-medium text-gray-800">Welcome back!</h2>
                           <p className="mt-1 text-base  text-gray-600 dark:text-gray-200">
                                Here's what we added while you were away
                            </p>
                           </div>
                           <div className="ml-3 h-7 flex items-center">
                             <button
                             	ref={cancelButtonRef}
                               type="button"
                               className=" rounded-md text-gray-800 focus:outline-none"
                               onClick={() => cancelModal()}
                             >
                               <span className="sr-only">Close panel</span>
                               <XIcon className="h-6 w-6" aria-hidden="true" />
                             </button>
                           </div>
                         </div>
                  </div>
                  <div className="mb-[75px]">
{
    entries && entries.map(entry=> <div
    className="pb-6 border-t border-gray-300"
    style={{ opacity: 1, transform: "none" }}
  >
    <p
      className="text-xl mt-3 px-6 font-bold text-gray-600 dark:text-white"
    >
      {entry.title}
    </p>
    <div className="flex mt-2 mb-3 px-6 flex-wrap items-center">
      <div className="mt-1 mr-2">
        <p className="bg-green-500 bg-opacity-10 text-green-600 dark:bg-green-500 dark:bg-opacity-10 dark:text-green-400 dark:border-green-500/10 border-green-600/10 text-xs px-2 py-0.5 flex font-medium border items-center rounded ">
          New
        </p>
      </div>
    </div>
    <div
            className="new-feature-markdown-container px-6 text-gray-600 content"
            dangerouslySetInnerHTML={{
              __html: convertMarkdownToHTML(entry.markdownDetails)
            }} />
 
  </div>)
}



                  </div>
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition.Root>
    );
};

export default ChangelogModal;